.authManagementSection {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.authManagementLabel {
    font: var(--exo-text-label-micro);
    color: var(--exo-color-font);
}

.authManagementCard {
    border: 1px solid var(--exo-color-border-secondary);
    border-radius: 8px;
    background: var(--exo-color-background-secondary);
    padding: var(--exo-spacing-standard);
    display: flex;
    flex-direction: column;
    gap: var(--exo-spacing-standard);
}

.authManagementHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--exo-spacing-small);
}

.authManagementInfo {
    display: flex;
    flex-direction: column;
    gap: var(--exo-spacing-2x-small);
}

.authManagementTitle {
    font-size: var(--exo-font-size-small);
    font-weight: 500;
    color: var(--exo-color-font);
}

.authManagementSubtitle {
    font-size: var(--exo-font-size-x-small);
    color: var(--exo-color-font-secondary);
}
